import React, { useEffect, useState } from "react";
import {
  ErrorMessage,
  MainImageBackground,
  MustListContent,
} from "src/components";

import styles from "./styles.module.scss";
import { UIButton, UICard, UICheckBox, UIText } from "src/components/uIKit";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import { images } from "src/assets/images/images";
import {
  CREDIT_CARD_BRAND,
  CreditCard,
  CreditCardStatus,
  MustListBodyList,
} from "src/utils/types";
import { API_RESULT, COLLECT_CARD_INSTRUCTION, PolictSupplier, ROUTES } from "src/utils/enums";
import {
  getCountries,
  getTaxRefundInfo,
} from "src/redux/slices/userSlice/UserApi";
import { useCustomNavigate } from "src/hooks/useCustomNavigate";
import ScreenReaderText from "src/components/accessibilityKit/screenReaderText/ScreenReaderText";
import { useLogAnalytics } from "src/hooks/useLogAnalytics";
import { useRouteParams } from "src/hooks/useRouteParams";
type Text = {
  title: string;
  ariaTitle: string;
};

const RepresentativeScreen: React.FC = () => {
  useLogAnalytics({ must_list: true });

  const {
    strings,
    fXEligibilityData,
    travelPolicyNumber,
    businessUnit,
    personalId,
    guid,
  } = useAppSelector((state) => state.app);
  const {
    taxRefundInfoResStatus,
    countriesResStatus,
    countries,
    getCCInfoRes,
    updateCCInfoRes,
  } = useAppSelector((state) => state.user);
  const { navigateTo } = useCustomNavigate();
  const dispatch = useAppDispatch();
  const { currentSource } = useRouteParams();
  const [isAcceptChecked, setIsAcceptChecked] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const [bodyList, setBodyList] = useState<MustListBodyList[]>([]);
  const [generalBodyList, setGeneralBodyList] = useState<MustListBodyList[]>([]);

  const [personalBodyList, setPersonalBodyList] = useState<MustListBodyList[]>([]);
  const title: Text = {
    title: strings.t_must_list_title,
    ariaTitle: strings.acc_t_must_list_title,
  };
  const subTitle: Text = {
    title: strings.t_must_list_sub_title,
    ariaTitle: strings.acc_t_must_list_sub_title,
  };
  const img = images.mainImage;
  const passportCard4LastDigits = fXEligibilityData.passportCard4LastDigits; //Bug 3432 fix

  const lastActiveCard = getCCInfoRes?.creditCards?.find(
    (card) => card.feCustCCStatus === CreditCardStatus.ACTIVE
  );
  const lastActiveCard4Digits = lastActiveCard?.feCC4LastDigits || "";


  const lastActiveCardFromUpdateCCInfo = updateCCInfoRes?.creditCards?.find(
    (card: CreditCard) => card.feCustCCStatus === CreditCardStatus.ACTIVE
  );

  const lastActiveCardFromGetCCInfo4Digits =
    lastActiveCardFromUpdateCCInfo?.feCC4LastDigits || "";





  const collectCardInstruction = fXEligibilityData.collectCardInstruction;
  const { visaMaxWalletLimit, visaLimitationMessageEnabled } = fXEligibilityData;
  const showVisaLimitationMessage = visaLimitationMessageEnabled === true;

  const selectedPolicy = fXEligibilityData.policyDetails?.find(
    (p) => p.policyDtoField.travelPolicyNumberField?.toString() === travelPolicyNumber
  ) ?? fXEligibilityData.policyDetails?.[0];
  const knowledgeCountryName = selectedPolicy?.countryOfDestinationDtoField?.[0]?.countryField ?? "";

  useEffect(() => {
    if (strings) {
      // all Labels from Task 6105
      setPersonalBodyList([
        {
          title: strings?.t_must_list_body_question_1?.replace(
            "XXXX",
            lastActiveCardFromGetCCInfo4Digits || lastActiveCard4Digits
          ),
          ariaLabel: strings.acc_t_must_list_body_question_1,
        },
        {
          title:
            collectCardInstruction === COLLECT_CARD_INSTRUCTION.COLLECT
              ? strings.t_must_list_body_question_2_collect
              : collectCardInstruction === COLLECT_CARD_INSTRUCTION.REPLACE
                ? strings.t_must_list_body_question_2_replace
                : collectCardInstruction === COLLECT_CARD_INSTRUCTION.USE_EXISTING
                  ? strings.t_must_list_body_question_2_use_existing?.replace(
                    "XXXX",
                    passportCard4LastDigits || ""
                  )
                  : strings.t_must_list_body_question_2_fixed,
          ariaLabel:
            collectCardInstruction === COLLECT_CARD_INSTRUCTION.COLLECT
              ? strings.acc_t_must_list_collect_instruction_1
              : collectCardInstruction === COLLECT_CARD_INSTRUCTION.REPLACE
                ? strings.acc_t_must_list_collect_instruction_2
                : collectCardInstruction === COLLECT_CARD_INSTRUCTION.USE_EXISTING
                  ? strings.acc_t_must_list_collect_instruction_3?.replace(
                    "XXXX",
                    passportCard4LastDigits || ""
                  )
                  : strings.acc_t_must_list_body_question_2_fixed,
        },
        ...(showVisaLimitationMessage && lastActiveCard?.feCCCardBrand === CREDIT_CARD_BRAND.VISA
          ? [
            {
              title: strings.t_must_list_body_visa_limitation?.replace(
                "X",
                String(visaMaxWalletLimit ?? "")
              ),
              ariaLabel: strings.acc_t_must_list_body_question_3_fixed?.replace(
                "X",
                String(visaMaxWalletLimit ?? "")
              ),
            },
          ]
          : []),
        ...(selectedPolicy?.policyDtoField?.taxRefundSupplierField === PolictSupplier.INOVAT
          ? [
            {
              title: strings.t_must_list_body_question_8_inovat?.replace("XXXX", knowledgeCountryName),
              ariaLabel: strings.acc_t_must_list_body_question_4_fixed?.replace("XXXX", knowledgeCountryName),
            },
          ]
          : []),
        ...(selectedPolicy?.policyDtoField?.taxRefundSupplierField === PolictSupplier.GLOBAL_BLUE
          ? [
            {
              title: strings.t_must_list_body_question_8_global_blue?.replace("XXXX", knowledgeCountryName),
              ariaLabel: strings.acc_t_must_list_body_question_8_global_blue?.replace("XXXX", knowledgeCountryName),
            },
          ]
          : []),
      ]);
      // all Labels from Task 6105
      setGeneralBodyList([
        {
          title: strings.t_must_list_body_question_3,
          ariaLabel: strings.acc_t_must_list_body_question_1_general,
        },
        {
          title: strings.t_must_list_body_question_4,
          ariaLabel: strings.acc_t_must_list_body_question_2_general,
        },
        {
          title: strings.t_must_list_body_question_10,
          ariaLabel: strings.acc_t_must_list_body_question_3_general,
        },
        {
          title: strings.t_must_list_body_question_5,
          ariaLabel: strings.acc_t_must_list_body_question_4_general,
        },
        {
          title: strings.t_must_list_body_question_6,
          ariaLabel: strings.acc_t_must_list_body_question_5_general,
        },
        {
          title: strings.t_must_list_body_question_7,
          ariaLabel: strings.acc_t_must_list_body_question_6_general,
        },
        {
          title: strings.t_must_list_body_question_9,
          ariaLabel: strings.acc_t_must_list_body_question_7_general,
        },
      ]);
    }
  }, [strings, knowledgeCountryName, collectCardInstruction, passportCard4LastDigits, showVisaLimitationMessage, visaMaxWalletLimit, selectedPolicy]);



  const handleAcceptCheckboxChange = () => {
    setIsAcceptChecked(!isAcceptChecked);
  };

  const onSubmit = () => {
    dispatch(
      getTaxRefundInfo({
        feCustTravalPolicyNumber: travelPolicyNumber,
        feGuid: guid,
        feCustPersId: personalId,
        feBU: businessUnit,
      })
    );
  };
  useEffect(() => {
    if (taxRefundInfoResStatus === API_RESULT.SUCCEEDED) {
      setShowErrorMessage(false);
      //
      dispatch(getCountries({}));
    } else if (taxRefundInfoResStatus === API_RESULT.FAILED) {
      setShowErrorMessage(true);
    }
  }, [taxRefundInfoResStatus]);

  useEffect(() => {
    if (countriesResStatus === API_RESULT.SUCCEEDED) {
      navigateTo(ROUTES.SUMMARY_SCREEN);
    } else if (countriesResStatus === API_RESULT.FAILED) {
      setShowErrorMessage(true);
    }
  }, [countriesResStatus]);

  return (
    <div className={styles.container}>
      <MainImageBackground
        desktopImageSrc={images.mainImage}
        mobileImageSrc={images.mainMobile}
      />

      <UICard>
        <>
          {/* <a
            id="link-back"
            href={`/${currentSource}/${ROUTES.ACTIVATE_CREDIT_CARD}`}
            className={styles.backButton}
            aria-describedby={"aria-label-text"}
          >
            <UIText
              isAriaHidden={true}
              text={strings.t_back}
              size={18}
              weight={400}
              style={styles.link}
            />
          </a> */}
          <div className={styles.redCardImageWrapper}>
            <img src={images.card} className={styles.redCardImage} alt="card" />
          </div>
          <ScreenReaderText
            text={[title.ariaTitle, subTitle.ariaTitle]}
            announnceDelay={2100}
          />
          <MustListContent
            title={title.title}
            subTitle={subTitle.title}
            personalHighlightsSubTitle={strings.t_must_list_personal_highlights_sub_title}
            fixedHighlightsTitle={strings.t_must_list_fixed_highlights_title}
            image={img}
            bodyList={generalBodyList}
            personalBodyList={personalBodyList}
          />
          <br />
          <div className={styles.acceptCheckboxWrapper}>
            <UICheckBox
              text={strings.t_must_list_accept_text}
              ariaLabel={strings.acc_t_must_list_accept_text}
              checked={isAcceptChecked}
              onChange={handleAcceptCheckboxChange}
              className={styles.acceptCheckbox}
            />
          </div>
          <br />
          <div className={styles.acceptButtonWrapper}>
            {showErrorMessage && (
              <>
                <ErrorMessage
                  message={strings.t_must_list_error_message}
                  ariaLabel={strings.acc_t_must_list_error_message}
                />
                <br />
              </>
            )}
            <UIButton
              tabIndex={0}
              title={strings.t_must_list_accept_button}
              ariaLabel={strings.acc_t_must_list_accept_button}
              onSubmit={onSubmit}
              disabled={
                !isAcceptChecked ||
                (taxRefundInfoResStatus === API_RESULT.LOADING || countriesResStatus === API_RESULT.LOADING)
              }
              isLoading={taxRefundInfoResStatus === API_RESULT.LOADING || countriesResStatus === API_RESULT.LOADING}
            />
          </div>
          <br />
        </>
      </UICard>
    </div>
  );
};

export default RepresentativeScreen;
